// extracted by mini-css-extract-plugin
export default {"container":"DbDemo_container__XT7U9"};